// Общие помощники для изображений: загрузка на сервер (нормализация, dedup по содержимому) и узел рисунка.
import type { JSONContent } from '@tiptap/core';
import type { AssetInfo } from './types';
import { api } from './api';
import { appStore } from './store';

export const IMAGE_MIME = /^image\/(png|jpe?g|gif|bmp|webp|tiff|x-emf|x-wmf|emf|wmf)$/i;
export const IMAGE_EXT = /\.(png|jpe?g|gif|bmp|webp|tiff?|emf|wmf)$/i;

export function isImageFile(f: File): boolean {
  return IMAGE_MIME.test(f.type) || IMAGE_EXT.test(f.name);
}

/** Загрузить изображение в assets текущего проекта. */
export async function uploadImage(blob: Blob, filename = ''): Promise<AssetInfo> {
  const pid = appStore.getState().projectId;
  if (!pid) throw new Error('Проект не открыт');
  return api.uploadAsset(pid, blob, filename || (blob instanceof File ? blob.name : 'image.png'));
}

/** Ширина рисунка по умолчанию: null - натуральный размер по DPI; шире поля (17 см) writer уменьшает сам. */
export function defaultWidth(_a: AssetInfo): string | null {
  return null;
}

/** JSON узла «рисунок» для вставки. */
export function figureNode(a: AssetInfo, caption = ''): JSONContent {
  return {
    type: 'figure',
    attrs: { src: a.name, width: defaultWidth(a), alt: '' },
    content: [{ type: 'caption', content: caption ? [{ type: 'text', text: caption }] : [] }],
  };
}

/** Картинка из data:URL (вставка из браузера/Word) -> Blob. */
export function dataUrlToBlob(url: string): Blob {
  const [head, data] = url.split(',', 2);
  const mime = (head.match(/data:([^;]+)/) || [])[1] || 'image/png';
  const bin = head.includes(';base64') ? atob(data) : decodeURIComponent(data);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return new Blob([arr], { type: mime });
}
